module.exports = __webpack_public_path__ + "assets/media/newExtensionIcon.c9158cb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newExtensionIcon.png
// module id = 2026
// module chunks = 0